const crossfadeDurationMs = 225;
const splitWrapper = "_35sscvipmk";
const wrapper = "_35sw10awe7q";
const linebreak = "_35sligwh08";
const toggle = "_35st1eau6l3";
const content = "_35sclm86jf";
const transitionWrapper = "_35st18p2jw";

export { content, crossfadeDurationMs, linebreak, splitWrapper, toggle, transitionWrapper, wrapper };
import "./_task.dropdown.style.linaria.module.css";
//# sourceMappingURL=_task.dropdown.style.js.map
